import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.admin.upload');
import { OnInit, Input, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-admin-upload',
template: templateSource || '',
    styles: [``],
})
export class PortalAdminUploadComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service) public service: Service) { }

    private _mode: 'org' | 'integrated' = 'org';

    @Input()
    public set mode(value: any) {
        const v = String(value || '').toLowerCase();
        const next = (v === 'integrated') ? 'integrated' : 'org';
        if (next !== this._mode) {
            this._mode = next;
            this.resetUpload();
        }
        this.service.render();
    }
    public get mode(): 'org' | 'integrated' {
        return this._mode;
    }

    @Input() toastRef: any = null;

    // Drag & Drop
    public dragging: boolean = false;

    // 파일 업로드
    public files: File[] = [];
    public uploading: boolean = false;
    public uploadProgress: number = 0;
    public uploadPhase: 'idle' | 'uploading' | 'processing' = 'idle';
    public result: any = null;
    public error: string = '';

    // Cancel
    public cancelling: boolean = false;

    // Per-file progress
    public currentFileIndex: number = 0;
    public totalFiles: number = 0;
    public currentFileName: string = '';

    // SSE processing progress
    public rowCurrent: number = 0;
    public rowTotal: number = 0;
    public phaseDetail: string = '';

    // 중복 파일 모달
    public dupModalOpen: boolean = false;
    public dupFiles: { name: string; action: 'existing' | 'rename'; newName: string }[] = [];
    private dupResolve: (() => void) | null = null;

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }

    ngOnDestroy() {
    }

    private apiUrl(fn: string) {
        return `/wiz/api/page.admin/${fn}`;
    }

    public get modeLabel(): string {
        return this._mode === 'integrated' ? '통합 데이터' : '기관 데이터';
    }

    public get modeDesc(): string {
        return this._mode === 'integrated'
            ? '연구자·성과물·저자관계 통합 CSV 데이터를 업로드합니다'
            : 'CSV, TSV, XLSX, TXT 파일을 업로드하여 DB에 적재합니다';
    }

    public get modeHint(): string {
        return this._mode === 'integrated'
            ? 'CSV / TSV / XLSX (문서번호·저자ID 기준 신규/수정)'
            : 'CSV / TSV / XLSX / TXT (org_id 기준 신규 삽입, 중복 건너뜀)';
    }

    // ─── Phase 헬퍼 ──────────────────────────────
    private phaseLabel(phase: string): string {
        switch (phase) {
            case 'parsing': return '행 분석 중';
            case 'researcher': return '연구자 처리 중';
            case 'publication': return '성과물 삽입 중';
            case 'publication_author': return '저자 매핑 중';
            case 'keyword': return '키워드 추출 중';
            case 'aggregate': return '집계 갱신 중';
            case 'inserting': return 'DB 적재 중';
            default: return 'DB 적재 중';
        }
    }

    private phaseUnit(phase: string): string {
        switch (phase) {
            case 'parsing': return '행';
            case 'researcher': return '명';
            case 'publication': return '건';
            case 'publication_author': return '건';
            case 'keyword': return '건';
            case 'aggregate': return '명';
            case 'inserting': return '건';
            default: return '행';
        }
    }

    // ─── Toast 헬퍼 (부모 toastRef 사용) ──────────────────────
    private updateToast(phase: string, message: string, progress: number = 0) {
        if (!this.toastRef) return;
        this.toastRef.show = true;
        this.toastRef.phase = phase;
        this.toastRef.message = message;
        this.toastRef.progress = progress;
        this.toastRef.rowCurrent = this.rowCurrent;
        this.toastRef.rowTotal = this.rowTotal;
        this.toastRef.fileIndex = this.currentFileIndex;
        this.toastRef.fileTotal = this.totalFiles;
        this.toastRef.fileName = this.currentFileName;
        this.toastRef.phaseDetail = this.phaseDetail;
        if (phase === 'done' || phase === 'error' || phase === 'cancelled') {
            if (this.toastRef._autoDismiss) this.toastRef._autoDismiss(5000);
        }
        if (this.toastRef._render) this.toastRef._render();
    }

    // ─── 파일 업로드 ────────────────────────────────────────
    public openFileDialog(input: HTMLInputElement) {
        input.click();
    }

    public onFileSelect(event: any) {
        const list: FileList | undefined = event?.target?.files;
        if (list && list.length > 0) {
            this.addFiles(Array.from(list));
        }
        if (event?.target) event.target.value = '';
    }

    public addFiles(newFiles: File[]) {
        const next = [...this.files];
        for (const f of newFiles || []) {
            if (!f) continue;
            next.push(f);
        }
        this.files = next;
        this.uploadProgress = 0;
        this.uploadPhase = 'idle';
        this.result = null;
        this.error = '';
        this.service.render();
    }

    public clearFiles() {
        this.files = [];
        this.uploadProgress = 0;
        this.uploadPhase = 'idle';
        this.result = null;
        this.error = '';
        this.service.render();
    }

    public removeFile(idx: number) {
        const next = [...this.files];
        next.splice(idx, 1);
        this.files = next;
        this.uploadProgress = 0;
        this.uploadPhase = 'idle';
        this.result = null;
        this.error = '';
        this.service.render();
    }

    public onDragOver(event: DragEvent) {
        event.preventDefault();
        this.dragging = true;
        this.service.render();
    }

    public onDragLeave(event: DragEvent) {
        event.preventDefault();
        this.dragging = false;
        this.service.render();
    }

    public onDrop(event: DragEvent) {
        event.preventDefault();
        this.dragging = false;
        const list = event?.dataTransfer?.files;
        if (list && list.length > 0) {
            this.addFiles(Array.from(list));
        }
        this.service.render();
    }

    public async cancelUpload() {
        if (this.cancelling) return;
        this.cancelling = true;
        this.updateToast('processing', '취소 요청 중... 잠시만 기다려주세요', this.uploadProgress);
        await this.service.render();

        try {
            await fetch(this.apiUrl('org_upload_cancel'), {
                method: 'POST',
                credentials: 'include'
            });
        } catch (e) { }
    }

    // ─── Step 1: 파일 저장 (XHR — 전송 진행률 표시) ────────────
    private saveFile(file: File, opts?: { saveName?: string }): Promise<any> {
        const self = this;
        const fileIdx = this.currentFileIndex;
        const fileTotal = this.totalFiles;
        const label = fileTotal > 1 ? `파일 ${fileIdx}/${fileTotal} ` : '';

        return new Promise<any>((resolve, reject) => {
            const form = new FormData();
            form.append('file', file, file.name);
            form.append('data_type', self._mode);
            if (opts?.saveName) form.append('save_name', opts.saveName);

            const xhr = new XMLHttpRequest();
            xhr.open('POST', this.apiUrl('save_upload_file'));
            xhr.withCredentials = true;

            xhr.upload.onprogress = (e) => {
                if (e.lengthComputable && e.total > 0) {
                    const pct = Math.round((e.loaded / e.total) * 100);
                    self.uploadProgress = Math.max(0, Math.min(100, pct));
                    self.uploadPhase = 'uploading';
                    self.updateToast('uploading', `${label}전송 중: ${file.name} (${self.formatSize(e.loaded)} / ${self.formatSize(e.total)})`, pct);
                    self.service.render();
                }
            };

            xhr.onerror = () => reject(new Error(`파일 "${file.name}" 네트워크 오류`));
            xhr.onabort = () => reject(new Error(`파일 "${file.name}" 업로드 취소`));
            xhr.onload = () => {
                try {
                    resolve(JSON.parse(xhr.responseText || '{}'));
                } catch (e) {
                    reject(new Error('서버 응답을 해석할 수 없습니다.'));
                }
            };

            xhr.send(form);
        });
    }

    // ─── Step 2: SSE 스트리밍 처리 ──────────────────────────
    private async streamProcess(filename: string, dataType: string): Promise<any> {
        const label = this.totalFiles > 1 ? `파일 ${this.currentFileIndex}/${this.totalFiles} ` : '';

        this.uploadPhase = 'processing';
        this.uploadProgress = 100;
        this.rowCurrent = 0;
        this.rowTotal = 0;
        this.phaseDetail = '';
        this.updateToast('processing', `${label}DB 적재 준비 중: ${filename}`, 100);
        await this.service.render();

        const form = new FormData();
        form.append('filename', filename);
        form.append('data_type', dataType);

        const response = await fetch(this.apiUrl('process_upload'), {
            method: 'POST',
            body: form,
            credentials: 'include',
        });

        if (!response.ok) {
            const text = await response.text();
            try {
                const json = JSON.parse(text);
                if (json?.code === 409 && json?.data?.processing) {
                    return json;
                }
                throw new Error(json?.data?.message || `서버 오류 (${response.status})`);
            } catch (e: any) {
                if (e?.message) throw e;
                throw new Error(`서버 오류 (${response.status})`);
            }
        }

        const reader = response.body!.getReader();
        const decoder = new TextDecoder();
        let buffer = '';
        let finalResult: any = null;
        let finalError: string = '';

        while (true) {
            const { done, value } = await reader.read();
            if (done) break;
            buffer += decoder.decode(value, { stream: true });

            const parts = buffer.split('\n\n');
            buffer = parts.pop() || '';

            for (const part of parts) {
                for (const line of part.split('\n')) {
                    if (!line.startsWith('data: ')) continue;
                    try {
                        const event = JSON.parse(line.slice(6));
                        switch (event.type) {
                            case 'progress': {
                                const current = event.current || 0;
                                const total = event.total || 0;
                                const phase = event.phase || '';
                                this.rowCurrent = current;
                                this.rowTotal = total;
                                this.phaseDetail = this.phaseLabel(phase);
                                const unit = this.phaseUnit(phase);
                                const msg = `${label}${this.phaseDetail}... ${current.toLocaleString()} / ${total.toLocaleString()} ${unit}`;
                                this.updateToast('processing', msg, 100);
                                await this.service.render();
                                break;
                            }
                            case 'complete':
                                finalResult = event.data;
                                break;
                            case 'error':
                                finalError = event.message || '처리 중 오류 발생';
                                break;
                            case 'heartbeat':
                            case 'start':
                                break;
                        }
                    } catch (e) { }
                }
            }
        }

        if (finalError) {
            throw new Error(finalError);
        }
        return { code: 200, data: finalResult || {} };
    }

    // ─── 중복 파일 모달 ──────────────────────────────────
    private fileNameMap: Map<string, { saveName?: string; useExisting?: boolean }> = new Map();

    private async checkDuplicates(files: File[]): Promise<boolean> {
        const names = files.map(f => f.name);
        try {
            const form = new FormData();
            form.append('filenames', JSON.stringify(names));
            const resp = await fetch(this.apiUrl('check_duplicate_filenames'), {
                method: 'POST', body: form, credentials: 'include'
            });
            const json = await resp.json();
            if (json?.code === 200) {
                const dups: string[] = json.data?.duplicates || [];
                if (dups.length > 0) {
                    this.dupFiles = dups.map(name => {
                        const base = name.replace(/\.[^.]+$/, '');
                        const ext = name.includes('.') ? '.' + name.split('.').pop() : '';
                        return { name, action: 'existing' as const, newName: base + '_new' + ext };
                    });
                    this.dupModalOpen = true;
                    await this.service.render();
                    return true;
                }
            }
        } catch (e) {
            console.error('중복 체크 실패:', e);
        }
        return false;
    }

    public async setDupAction(idx: number, action: 'existing' | 'rename') {
        this.dupFiles[idx].action = action;
        await this.service.render();
    }

    public async cancelDupModal() {
        this.dupModalOpen = false;
        this.dupFiles = [];
        this.dupResolve = null;
        await this.service.render();
    }

    public async confirmDupModal() {
        for (const df of this.dupFiles) {
            if (df.action === 'rename' && !df.newName.trim()) {
                return;
            }
        }
        this.fileNameMap.clear();
        for (const df of this.dupFiles) {
            if (df.action === 'existing') {
                this.fileNameMap.set(df.name, { useExisting: true });
            } else {
                const ext = df.name.includes('.') ? '.' + df.name.split('.').pop() : '';
                let newName = df.newName.trim();
                if (!newName.endsWith(ext)) newName += ext;
                this.fileNameMap.set(df.name, { saveName: newName });
            }
        }
        this.dupModalOpen = false;
        this.dupFiles = [];
        await this.service.render();
        await this.doUpload();
    }

    public async insertDB() {
        if (!this.files.length || this.uploading) return;

        this.fileNameMap.clear();
        const hasDup = await this.checkDuplicates(this.files);
        if (hasDup) return;

        await this.doUpload();
    }

    private async doUpload() {
        if (!this.files.length || this.uploading) return;

        this.uploading = true;
        this.cancelling = false;
        this.uploadProgress = 0;
        this.uploadPhase = 'uploading';
        this.result = null;
        this.error = '';
        this.rowCurrent = 0;
        this.rowTotal = 0;
        this.phaseDetail = '';

        const allFiles = [...this.files];
        this.totalFiles = allFiles.length;
        this.currentFileIndex = 0;
        this.currentFileName = '';

        const mode = this._mode;

        this.updateToast('uploading', '파일 전송 중...', 0);
        await this.service.render();

        // Accumulated results
        const accResult: any = mode === 'integrated'
            ? { researcher_inserted: 0, researcher_updated: 0, publication_inserted: 0, publication_updated: 0, relation_inserted: 0, keyword_inserted: 0, total_rows: 0, error_count: 0, file_count: 0, files: [] }
            : { inserted: 0, skipped: 0, error_count: 0, file_count: 0, files: [], cancelled: false, rolled_back: 0 };

        for (let i = 0; i < allFiles.length; i++) {
            if (this.cancelling) break;

            const file = allFiles[i];
            this.currentFileIndex = i + 1;
            this.currentFileName = file.name;
            this.uploadProgress = 0;
            this.uploadPhase = 'uploading';
            this.rowCurrent = 0;
            this.rowTotal = 0;
            this.phaseDetail = '';

            const label = allFiles.length > 1 ? `파일 ${i + 1}/${allFiles.length} ` : '';
            this.updateToast('uploading', `${label}전송 중: ${file.name}`, 0);
            await this.service.render();

            try {
                const opts = this.fileNameMap.get(file.name);

                if (opts?.useExisting) {
                    // 기존 파일 사용 — 파일 업로드 없이 서버의 기존 파일로 SSE 처리
                    const json = await this.streamProcess(file.name, mode);
                    if (json?.code === 409 && json?.data?.processing) {
                        this.error = json?.data?.message || '동일한 파일이 이미 처리 중입니다.';
                        this.updateToast('error', `⏳ ${this.error}`, 0);
                        break;
                    }
                    this.mergeResult(accResult, json?.data || {}, mode);
                } else {
                    // Step 1: 파일 저장
                    const saveJson = await this.saveFile(file, opts);
                    if (saveJson?.code === 409 && saveJson?.data?.processing) {
                        this.error = saveJson?.data?.message || '동일한 파일이 이미 처리 중입니다.';
                        this.updateToast('error', `⏳ ${this.error}`, 0);
                        break;
                    }
                    if (saveJson?.code !== 200) {
                        this.error = saveJson?.data?.message || `파일 "${file.name}" 저장에 실패했습니다.`;
                        this.updateToast('error', this.error, 0);
                        break;
                    }

                    const saveData = saveJson.data || {};

                    // 이미 처리된 파일 (중복 감지 with cached_result)
                    if (saveData.duplicate && saveData.cached_result) {
                        const cr = saveData.cached_result;
                        this.mergeResult(accResult, cr, mode);
                        accResult.duplicate = true;
                        continue;
                    }

                    // Step 2: SSE 스트리밍 처리
                    const processJson = await this.streamProcess(saveData.filename || file.name, mode);
                    if (processJson?.code === 409 && processJson?.data?.processing) {
                        this.error = processJson?.data?.message || '동일한 파일이 이미 처리 중입니다.';
                        this.updateToast('error', `⏳ ${this.error}`, 0);
                        break;
                    }
                    const pData = processJson?.data || {};
                    if (pData.cancelled) {
                        accResult.cancelled = true;
                        accResult.rolled_back = (accResult.rolled_back || 0) + (pData.rolled_back || 0);
                        accResult.file_count++;
                        if (pData.files) accResult.files.push(...pData.files);
                        this.error = `업로드가 중단되었습니다. ${this.formatNumber(pData.rolled_back || 0)}건의 삽입 데이터가 삭제되었습니다.`;
                        this.updateToast('cancelled', this.error, 0);
                        break;
                    }
                    this.mergeResult(accResult, pData, mode);
                }
            } catch (e: any) {
                this.error = e?.message || String(e);
                this.updateToast('error', this.error, 0);
                break;
            }
        }

        if (!this.error) {
            this.result = accResult;
            this.files = [];
            const dupSuffix = accResult.duplicate ? ' (기존 처리 결과)' : '';
            const msg = mode === 'integrated'
                ? `완료: 연구자 ${this.formatNumber((accResult.researcher_inserted || 0) + (accResult.researcher_updated || 0))}건, 성과물 ${this.formatNumber((accResult.publication_inserted || 0) + (accResult.publication_updated || 0))}건${dupSuffix}`
                : `완료: 신규 ${this.formatNumber(accResult.inserted || 0)}건, 건너뜀 ${this.formatNumber(accResult.skipped || 0)}건${dupSuffix}`;
            this.updateToast('done', msg, 100);
        }

        this.uploading = false;
        this.cancelling = false;
        this.uploadPhase = 'idle';
        this.currentFileIndex = 0;
        this.currentFileName = '';
        this.totalFiles = 0;
        this.rowCurrent = 0;
        this.rowTotal = 0;
        this.phaseDetail = '';
        await this.service.render();
    }

    private mergeResult(acc: any, data: any, mode: string) {
        if (mode === 'integrated') {
            acc.researcher_inserted += (data.researcher_inserted || 0);
            acc.researcher_updated += (data.researcher_updated || 0);
            acc.publication_inserted += (data.publication_inserted || 0);
            acc.publication_updated += (data.publication_updated || 0);
            acc.relation_inserted += (data.relation_inserted || 0);
            acc.keyword_inserted += (data.keyword_inserted || 0);
            acc.total_rows += (data.total_rows || 0);
        } else {
            acc.inserted += (data.inserted || 0);
            acc.skipped += (data.skipped || 0);
        }
        acc.error_count += (data.error_count || 0);
        acc.file_count++;
        if (data.files) acc.files.push(...data.files);
    }

    // ─── 에러 상세 ─────────────────────────────────────
    public showErrorDetail: boolean = false;

    public get allErrors(): any[] {
        if (!this.result?.files) return [];
        const errs: any[] = [];
        for (const f of this.result.files) {
            if (f.errors && f.errors.length > 0) {
                for (const e of f.errors) {
                    errs.push({ filename: f.filename || '', line: e.line, error: e.error });
                }
            }
        }
        return errs;
    }

    public toggleErrorDetail() {
        this.showErrorDetail = !this.showErrorDetail;
        this.service.render();
    }

    // ─── 파일별 상세 모달 (통합 업로드) ──────────────────────
    public fileDetailOpen: boolean = false;
    public fileDetailExpandedIdx: number = -1;

    public openFileDetail() {
        this.fileDetailOpen = true;
        this.fileDetailExpandedIdx = -1;
        this.service.render();
    }

    public closeFileDetail() {
        this.fileDetailOpen = false;
        this.fileDetailExpandedIdx = -1;
        this.service.render();
    }

    public toggleFileExpand(idx: number) {
        this.fileDetailExpandedIdx = this.fileDetailExpandedIdx === idx ? -1 : idx;
        this.service.render();
    }

    // ─── 유틸 ────────────────────────────────────────
    public formatNumber(n: number): string {
        if (!n) return '0';
        return n.toLocaleString();
    }

    public formatSize(bytes: number): string {
        if (bytes < 1024) return bytes + ' B';
        if (bytes < 1048576) return (bytes / 1024).toFixed(1) + ' KB';
        return (bytes / 1048576).toFixed(1) + ' MB';
    }

    public formatTotalSize(): string {
        let total = 0;
        for (const f of this.files) total += f.size || 0;
        return this.formatSize(total);
    }

    public resetUpload() {
        this.files = [];
        this.uploadProgress = 0;
        this.uploadPhase = 'idle';
        this.result = null;
        this.error = '';
        this.cancelling = false;
        this.currentFileIndex = 0;
        this.currentFileName = '';
        this.totalFiles = 0;
        this.rowCurrent = 0;
        this.rowTotal = 0;
        this.phaseDetail = '';
        this.fileDetailOpen = false;
        this.fileDetailExpandedIdx = -1;
        this.dupModalOpen = false;
        this.dupFiles = [];
        this.fileNameMap.clear();
        this.service.render();
    }
}

export default PortalAdminUploadComponent;